import styled from "styled-components";
import moment from "moment";
import MensajeNoHayDatos from "./MensajeNoHayDatos";

function DashboardAdmin({ menus }) {
  return (
    <Container>
      <Titulo>Pedidos Resumen</Titulo>
      {menus.length === 0 ? (
        <MensajeNoHayDatos mensaje="No se han creado menús para clientes" />
      ) : (
        <Grid>
          {menus.map((menu) => (
            <Card key={menu.id}>
              <CardHeader>
                <p>{moment(menu.fecha).format("dddd, D MMMM YYYY")}</p>
              </CardHeader>
              <CardContent>
                <h4>{menu.plato.nombre}</h4>
                <p>Pedidos: {menu.pedidos.length}</p>
                <Pedidos>
                  {menu.pedidos.length === 0 ? (
                    <p className="norecords">No se han hecho pedidos aún</p>
                  ) : (
                    menu.pedidos.map((pedido, i) => (
                      <Cliente key={i}>
                        <p>{pedido.cliente.nombre}</p>
                        <p>{pedido.cliente.cell}</p>
                        <p>{pedido.cliente.correo}</p>
                      </Cliente>
                    ))
                  )}
                </Pedidos>
              </CardContent>
            </Card>
          ))}
        </Grid>
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 2rem;
  margin-bottom: 10px;
  p {
    font-weight: 300;
  }
`;

const Titulo = styled.h2`
  font-family: "Caveat", cursive;
  font-size: 2rem;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
`;

const Card = styled.div`
  width: 100%;
  padding: 1rem;
  margin-bottom: 30px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #f2f2f2;
  -webkit-box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;
  box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;
`;

const CardHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  margin-bottom: 10px;

  p {
    text-transform: capitalize;
  }
`;

const CardContent = styled.div`
  margin-bottom: 10px;
  img {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .ocultar {
    width: 100%;
    padding: 0.5rem;
    cursor: pointer;
    color: #fff;
    background: #f28705;
    &:hover {
      background: #f2a922;
    }
    border: none;
    outline: 0;
    border-radius: 5px;
  }
  .precio {
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 20px;
  }
  .descripcion {
    text-align: justify;
    margin-top: 10px;
    font-size: 12px;
    height: 5rem;
    max-height: 5rem;
    overflow-y: scroll;
  }
`;

const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  @media (min-width: 500px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
`;

const Pedidos = styled.div`
  margin-top: 10px;
  border-top: 2px solid #262626;
  font-size: 12px;
  height: 5rem;
  max-height: 5rem;
  overflow-y: scroll;
  .norecords {
    color: #d92a1a;
    font-size: 15px;
    text-align: center;
  }
`;

const Cliente = styled.div`
  width: 100%;
  padding: 0.2rem;
  margin-top: 5px;
  margin-bottom: 5px;
  background: #f2f2f2;
  border-bottom: 1px solid #262626;
`;

export default DashboardAdmin;
